import { render, staticRenderFns } from "./categoria-item.vue?vue&type=template&id=287993be&"
import script from "./categoria-item.vue?vue&type=script&lang=js&"
export * from "./categoria-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports